var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap",style:(_vm.contactNumberStyle)},[(_vm.hasStart)?_c('span',{staticClass:"start",staticStyle:{"color":"#f04134"}},[_vm._v("* ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }